import type { LanguageCode } from "../constants";
import { usei18n } from "./use-i18n";

export type Locale = {
  language: LanguageCode;
};

export const useLocale = (): { locale: Locale } => {
  const { getLanguage } = usei18n();
  const language = getLanguage();

  return { locale: { language: language as LanguageCode } };
};
